import React from 'react';

export type FilterContainerProps = {
  children: React.ReactNode;
};

export function FilterContainer({ children }: FilterContainerProps) {
  return <div className="filter-button">{children}</div>;
}
